import { useCreateSearchFilterMutation } from '@entities/search'

import { POSTCreateSearchType } from '@types'

import { transformSearchFilterDailyRangeField } from '../lib/transformSearchFilterDailyRangeField'

interface CreateSearchFilterManagerHookProps {
  searchFilterTitle: string
  onCreateFilter: () => void
}

export const useCreateSearchFilterManager = (props: CreateSearchFilterManagerHookProps) => {
  const { searchFilterTitle, onCreateFilter } = props

  const [createSearchFilter, { isLoading: isLoadingCreateSearchFilter }] =
    useCreateSearchFilterMutation()

  const handleCreateSearchFilter = (createSearchPayload: POSTCreateSearchType) => {
    createSearchFilter({
      ...transformSearchFilterDailyRangeField(createSearchPayload),
      title: searchFilterTitle,
    })
      .unwrap()
      .then(onCreateFilter)
      .catch(error => {
        console.error(
          '[useCreateSearchFilterManager] error in handleCreateSearchFilter:',
          error.message
        )
      })
  }

  return { handleCreateSearchFilter, isLoadingCreateSearchFilter }
}
